import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Layout, Row, Typography, List, Card } from "antd";
import useLandingPage from "../../custom-hooks/useLandingPage";
import useIsMobile from "../../custom-hooks/useIsMobile";
import Spinner from "../Spinner";
import Sidebar from "./Sidebar";

import "./root.less";

const { Content } = Layout;
const { Title } = Typography;
const Home = () => {
  const [posts, isLoading] = useLandingPage();
  const [data, setData] = useState([]);
  const [isMobile] = useIsMobile();

  useEffect(() => {
    const formattedData = posts.map((post) => ({
      title: post.fields.title,
      href: `/post/${post.fields.slug}`,
      description: post.fields.shortDescription,
      content:
        post.fields.content.content[0]?.content[0]?.value.split(". ")[0] +
        "...",
      imageUrl: post.fields.featuredImage.fields.file.url,
      date: post.fields.publishedDate,
    }));
    setData(formattedData);
  }, [posts]);

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <Layout>
      <Layout>
        <Content className="home">
          <Row className="posts">
            <Card style={{ width: "100%" }}>
              <List
                itemLayout={isMobile ? "horizontal" : "vertical"}
                pagination={{
                  pageSize: 7,
                  align: "center",
                }}
                dataSource={data}
                renderItem={(item) => (
                  <List.Item
                    key={item.title}
                    extra={
                      isMobile ? null : (
                        <img
                          width={272}
                          alt="featured"
                          src={item.imageUrl}
                          style={{
                            objectFit: "cover",
                            aspectRatio: "1/1",
                            borderRadius: "3px",
                          }}
                        />
                      )
                    }
                  >
                    <List.Item.Meta
                      title={
                        <Link to={item.href}>
                          <Title level={3}>{item.title}</Title>
                        </Link>
                      }
                      description={item.date}
                    />
                    {isMobile ? null : <p>{item.content}</p>}
                  </List.Item>
                )}
              />
            </Card>
          </Row>
        </Content>
      </Layout>
      <Sidebar />
    </Layout>
  );
};

export default Home;
